
import { Component, Mixins } from 'vue-property-decorator';
import UserRightsMixin from '~/mixins/UserRightsMixin';
import { ConfigModule } from '~/store/modules/config';
import { DocumentationModule } from '~/store/modules/documentation';
import { LayoutModule } from '~/store/modules/layout';
import DarkThemeInfoMixin from '~common-mixins/DarkThemeInfoMixin';
import { AppModule } from '~common-store/modules/app';

@Component({})
export default class TheSideMenu extends Mixins(DarkThemeInfoMixin, UserRightsMixin) {

    get isSideMenuOpen() {
        return LayoutModule.isSideMenuOpen;
    }

    get documentationLinks() {
        return DocumentationModule.environmentLinks;
    }

    get linkItems() {
        const linkItems = [
            {
                routeName: 'index',
                text: 'Home',
                icon: 'mdi-home',
            },
            {
                routeName: 'logs',
                text: 'Logs',
                icon: 'mdi-file-document',
            },
        ];
        if (this.documentationLinks?.user?.length > 0) {
            linkItems.push({
                routeName: 'documentation',
                text: 'Documentation',
                icon: 'mdi-information',
            });
        }
        if (this.isAllowed('WeatherExtract')) {
            linkItems.push({
                routeName: 'weather-extract',
                text: 'Weather Extract',
                icon: 'mdi-weather-cloudy',
            });
        }
        if (this.isAllowed('RemoteFeatureFlagsNetatmo')) {
            linkItems.push({
                routeName: 'remote-feature-flags',
                text: 'Feature Flags',
                icon: 'mdi-flag',
            });
        }
        return linkItems;
    }

    goToDashboard() {
        const baseUrl = ConfigModule.usersManagementUrl;
        window.location.href = `${baseUrl}/${AppModule.adminApp}/dashboard`;
    }
}
